// src/components/RouteError.tsx
import React from 'react';
import { isRouteErrorResponse, useRouteError, Link } from 'react-router-dom';

export default function RouteError() {
  const error = useRouteError();
  let message = 'Something went wrong. Please try again.';
  if (isRouteErrorResponse(error)) {
    message = error.statusText || message;
  } else if (error instanceof Error) {
    message = error.message || message;
  }

  return (
    <main className="min-h-dvh grid place-items-center bg-gradient-to-br from-[#050915] via-[#0b1224] to-[#111e32] text-white px-4">
      <div className="w-full max-w-md rounded-3xl border border-white/15 bg-white/10 backdrop-blur-xl p-6 text-center shadow-2xl shadow-black/40">
        <div className="text-sm uppercase tracking-[0.3em] text-white/60">BiteWise</div>
        <h1 className="mt-2 text-xl font-semibold">Something went wrong</h1>
        <p className="mt-2 text-sm text-white/70">{message}</p>
        <div className="mt-5 flex flex-col sm:flex-row gap-2 justify-center">
          <button
            type="button"
            className="rounded-full bg-white text-slate-900 px-4 py-2 text-sm font-semibold"
            onClick={() => window.location.reload()}
          >
            Reload
          </button>
          <Link
            to="/home"
            className="rounded-full border border-white/20 px-4 py-2 text-sm text-white/80 hover:text-white"
          >
            Go Home
          </Link>
        </div>
      </div>
    </main>
  );
}
